import { environment } from '../../environment.enum';
import { getEnvKey } from '../../environments';
import { ServiceManager } from '../../services/service-manager';
import styles from './BuildingInfo.module.css';

const BuildingInfo = ({ currentBuilding }) => (
    <div className={styles.BuildingInfo} data-testid="BuildingInfo">
        {currentBuilding.props && currentBuilding.props.info && (<div>
            <h2>Specificatie gebouw</h2>
            <div className={styles.half}>
                <dl>
                    <dt>Grondvlak</dt>
                    <dd data-testid="Ground">{currentBuilding.props.buildingLength} x {currentBuilding.props.buildingWidth} m</dd>
                    <dt>Hoogte</dt>
                    <dd data-testid="Height">{currentBuilding.props.buildingHeight} m</dd>
                    <dt>Woningen</dt>
                    <dd data-testid="NrApartments">{currentBuilding.props.totalAmountOfAllUnits.map(u => u.amount).reduce((p, c) => p + c, 0)}</dd>
                    <dt>Verdiepingen</dt>
                    <dd data-testid="Floors">{ServiceManager.buildingHelperService.getBuildingFloors(currentBuilding).length}</dd>
                </dl>
            </div>
            <div className={styles.half}>
                <dl>
                    <dt>BVO</dt>
                    <dd data-testid="TotalGFA">{Math.round(currentBuilding.props.info.totalGFA).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡</dd>
                    <dt>GO</dt>
                    <dd data-testid="TotalUFA">{Math.round(currentBuilding.props.info.totalUFA).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡</dd>
                    <dt>GO/BVO</dt>
                    <dd data-testid="UFAGFA">{(currentBuilding.props.info.totalUFA / currentBuilding.props.info.totalGFA).toFixed(2)}</dd>
                </dl>
            </div>
        </div>)}
    </div>
);

export default BuildingInfo;
